<script setup lang="ts">
import type { DropdownMenuItem } from "@nuxt/ui"

const LangsStore = useLangsStore()

const UserStore = useUserStore()
defineProps<{
	collapsed?: boolean
}>()

// const user = ref({
// 	name: 'Dexterial',
// 	avatar: {
// 		src: 'https://github.com/dexterial.png',
// 		alt: 'Dexterial',
// 	},
// })

// const users = await getCurrentUser()
</script>

<template>
	<!-- {{ UserStore.user_full.auth }} -->
	<!-- {{ UserStore.user_full?.auth?.photoURL }} -->
	<div>
		<USelect
			v-model="LangsStore.context.lang_id"
			:items="LangsStore.langs_ids"
			class="mb-2 w-full"
			:leading-icon="'i-lucide-globe'"
			:collapsed="collapsed"
			:ui="{
				base: collapsed ? 'w-12' : 'w-(--reka-dropdown-menu-trigger-width)',
				content: collapsed ? 'w-full' : 'w-(--reka-dropdown-menu-trigger-width)',
			}"
			@change="LangsStore.changeLang($event.target)"
		/>

		<UColorModeSelect
			:collapsed="collapsed"
			class="mb-2 w-full"
			:ui="{
				base: collapsed ? 'w-12' : 'w-(--reka-dropdown-menu-trigger-width)',
				content: collapsed ? 'w-full' : 'w-(--reka-dropdown-menu-trigger-width)',
			}"
		/>
		<AdminSettingsPalette :collapsed="collapsed" />
	</div>
</template>
